/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

jQuery(function($) {

  let windWidth = $(window).width();
  let windHeight = $(window).height();

  $(window).resize(function () {
    windWidth = $(window).width();
    windHeight = $(window).height();
  });

  let footerPosition = $('.site-footer').offset().top;

  let thisBlock = $('.wp-block-yuna-serena-stays-house-booking');

  if ( windWidth < 999 ){

    $(document).scroll(function() {

      let scrollPosition = $(this).scrollTop();

      console.log(scrollPosition, footerPosition);

      if ( scrollPosition > 10 && scrollPosition < ( footerPosition - 100 )) {
        thisBlock.addClass('show-booking');
      } else {
        thisBlock.removeClass('show-booking');
      }
    });
  }
});
